import React from 'react'
import './Loade.css'

const Loader = () => {
  return (
    <div className=' bg-black w-full h-screen'>
  	<div class="loader">
   <div data-glitch="Loading..." class="glitch">Loading...</div>
</div>
    </div>
  )
}

export default Loader
